/**
 * Stepper: 36px indicators — incomplete white/sand border, active navy fill + 4px halo, complete leaf fill with navy check.
 * Separator turns leaf.500 when complete. Prefer <WizardProgress> (src/components/ui) which wraps this in the sunken band + progress rail.
 */
const mdVars = {
  "--stepper-indicator-size": "2.25rem",
  "--stepper-icon-size": "1rem",
  "--stepper-title-font-size": "0.875rem",
  "--stepper-description-font-size": "0.75rem",
  "--stepper-accent-color": "colors.leaf.500",
};

export const Stepper = {
  baseStyle: {
    stepper: { gap: 0, "--stepper-accent-color": "colors.leaf.500" },
    step: { gap: 3 },
    indicator: {
      borderWidth: "1px",
      borderColor: "border.strong",
      bg: "surface.card",
      color: "text.muted",
      fontFamily: "body",
      fontWeight: 700,
      fontSize: "0.8125rem",
      transitionProperty: "common",
      transitionDuration: "normal",
      "&[data-status=incomplete]": { borderWidth: "1px" },
      "&[data-status=active]": {
        borderWidth: "1px",
        bg: "navy.900",
        borderColor: "navy.900",
        color: "white",
        boxShadow: "0 0 0 4px rgba(19,27,77,0.12)",
      },
      "&[data-status=complete]": { bg: "leaf.500", borderColor: "leaf.500", color: "navy.900" },
    },
    separator: {
      bg: "border.default",
      "&[data-status=complete]": { bg: "leaf.500" },
      "&[data-orientation=horizontal]": { h: "2px", mx: 3 },
    },
    title: {
      fontFamily: "body",
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "text.muted",
      whiteSpace: "nowrap",
      "&[data-status=active]": { color: "text.primary", fontWeight: 700 },
      "&[data-status=complete]": { color: "text.secondary" },
    },
    description: { fontSize: "0.75rem", color: "text.muted", fontWeight: 500 },
    number: { fontWeight: 700, fontSize: "0.8125rem" },
    icon: { w: "1rem", h: "1rem" },
  },
  sizes: {
    sm: {
      stepper: {
        ...mdVars,
        "--stepper-indicator-size": "1.75rem",
        "--stepper-icon-size": "0.875rem",
        "--stepper-title-font-size": "0.8125rem",
      },
    },
    md: { stepper: mdVars },
    lg: { stepper: { ...mdVars, "--stepper-indicator-size": "2.5rem", "--stepper-title-font-size": "0.9375rem" } },
  },
  defaultProps: { size: "md", colorScheme: "leaf" },
};
